import React from 'react';
import PropTypes from 'prop-types';

import TextField from './TextField';
import phoneValidator from '../../../helpers/validators/phoneValidator';

export default class PhoneNumberField extends React.PureComponent {
    static propTypes = {
        /** html id required to connect the input with the label */
        id: PropTypes.string.isRequired,

        /** Label contents, usually text */
        label: PropTypes.string
    };

    static defaultProps = {
        label: 'Phone'
    };

    textFieldRef = React.createRef();

    validate = () => {
        return this.textFieldRef.current.validate();
    }

    render() {
        const { id, label, ...rest } = this.props;

        return (
            <TextField
                ref={this.textFieldRef}
                id={id}
                type="tel"
                label={label}
                validator={phoneValidator}
                shouldReformatValue
                {...rest} />
        );
    }
}